import gql from 'graphql-tag';

const GET_ALL_TECH_GROUP = gql`
  query {
    getTechnicianGroups {
      groupId
      name
      description
      userList {
        userId
        name
        firstName
        lastName
        email
      }
    }
  }
`;

const GET_ALL_TECHNICIAN_GROUPS = gql`
  query {
    getTechnicianGroups {
      groupId
      name
      description
    }
  }
`;

const GET_ALL_TECH_GROUP_DETAILS = gql`
  query($isMSPProduct: Boolean!) {
    getTechnicianGroups {
      groupId
      name
      description
      userList {
        userId
        name
        firstName
        lastName
        email
      }
      clientList @include(if: $isMSPProduct) {
        accountId
        name
      }
      siteList @skip(if: $isMSPProduct) {
        id
        name
      }
      accessAllClients @include(if: $isMSPProduct)
      accessAllSites @skip(if: $isMSPProduct)
    }
  }
`;

const GET_ALL_TECHS_NEW = gql`
  query getTechnicianList($input: GetTechnicianListInput!) {
    getTechnicianList(input: $input) {
      userList {
        userId
        name
        firstName
        lastName
        email
      }
    }
  }
`;

// const GET_ALL_TECHS = gql`
//   query {
//     getAllTechnicians {
//       userId
//       name
//       firstName
//       lastName
//       email
//     }
//   }
// `;

const GET_TECHNICIAN_GROUP = gql`
  query($id: ID!, $isMSPProduct: Boolean!) {
    getGroup(groupId: $id) {
      groupId
      name
      description
      userList {
        userId
        firstName
        lastName
        email
      }
      clientList @include(if: $isMSPProduct) {
        accountId
        name
      }
      siteList @skip(if: $isMSPProduct) {
        id
        name
      }
      techAutoAssignmentMethod
      accessAllClients @include(if: $isMSPProduct)
      accessAllSites @skip(if: $isMSPProduct)
    }
  }
`;

const GET_ALLOWED_TECHNICIAN_GROUPS = gql`
  query($input: GetAllowedTechnicianGroupsInput!) {
    getAllowedTechnicianGroups(input: $input) {
      groupId
      name
      userList {
        userId
        email
        firstName
        lastName
      }
    }
  }
`;

export {
  GET_ALL_TECH_GROUP,
  GET_ALL_TECH_GROUP_DETAILS,
  GET_ALL_TECHS_NEW,
  GET_TECHNICIAN_GROUP,
  GET_ALL_TECHNICIAN_GROUPS,
  GET_ALLOWED_TECHNICIAN_GROUPS
};
